import React, { useContext, useState, useEffect, MouseEventHandler, useCallback } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent, GridEditChangeEvent, GridItemChangeEvent, GridCustomCellProps, GridRowProps} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent, NumericTextBox, NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import {SiteEntry,ATOLDeadlines, NewDeadline } from '../../services/interfaces';
import { deletePubDeadline, deleteSingleDeadline, getDeadlineList, saveDeadline } from '../../services/apiAdminService';
import { process, State, DataResult, GroupDescriptor } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { EditDescriptor, PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { PubList, SiteList, StatusList } from '../FormComponents';
import { DropDownListChangeEvent, MultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import { TimePicker, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
};



interface editProps{
    title: string,
    onSave: (dl:NewDeadline) => void;
    onClose: () => void;
    action:string
}


const NewDialog=(props:editProps)=>{
    const pageContext = useContext(PageContext);

    const [newDeadline,setNewDeadline]=useState<NewDeadline>({
        Type:[],
        Section:[],
        Days:0,
        Time:""
    });


    const setDeadline=()=>{

    }

    const sectionChanged=(e:MultiSelectChangeEvent)=>{
        setNewDeadline({...newDeadline, Section:e.value});
    }

    const typeChanged=(e:MultiSelectChangeEvent)=>{
        let type=e.value;
        switch (e.value){
            case "BOOKED":
                type="EORDER";
                break;
            case "MATERIALS IN":
                type="MATERIALSIN";
                break;
            case "PROOF OUT":
                type="PROOFOUT"
                break;
            case "CORRECTIONS":
                type="ECORR"
                break;
        }
        setNewDeadline({...newDeadline, Type:type});
    }

    const daysChanged = (e:InputChangeEvent)=>{
        setNewDeadline({...newDeadline,Days:Number(e.value)});
    }
     const timeChanged = (e:TimePickerChangeEvent)=>{
        var locale=pageContext?.glSettings.Locale

        const selTime= e.value?.toLocaleTimeString(locale,{hour:'numeric', minute:'2-digit', hour12:true}).toUpperCase()||"";

        setNewDeadline({...newDeadline,Time:selTime});
    }



useEffect(()=>{
    //console.log(newDeadline);

},[newDeadline])


return(
        <>
        <Dialog title="Add New Deadline" onClose={props.onClose} width={500}>
            {/* {showDupConfirm?<ConfirmDialog title='Duplicate Publication' message='This will copy all the settings for the selected publication to a new publication. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDupConfirmWarning} onConfirm={confirmDuplicate}  ></ConfirmDialog>:null}
            {showDelConfirm?<ConfirmDialog title='Delete Publication' message='This will permanently delete the selected publication. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisPub}  ></ConfirmDialog>:null} */}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Type:</Label></Col>
                <Col xs="9">
                    <MultiSelect
                        data={["BOOKED","MATERIALS IN","CR MATERIALS IN","PROOF OUT","CR PROOF OUT","CORRECTIONS","PAGINATION"]}
                        onChange={typeChanged}
                    >
                    </MultiSelect>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Section:</Label></Col>
                <Col xs="9">
                    <MultiSelect
                        data={["MAIN","EARLY RUN","ADVANCED","SOFT"]}
                        onChange={sectionChanged}
                    >
                    </MultiSelect>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="12"><Label className='mb-2'>Default Settings:</Label></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Days:</Label></Col>
                <Col xs="9">
                    <Input type='number' min={0} onChange={daysChanged}></Input>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Time:</Label></Col>
                <Col xs="9">
                    <TimePicker onChange={timeChanged}></TimePicker>
                </Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"}onClick={() => props.onSave(newDeadline)}>Add</Button>
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

function timeStringToDate(timeStr:string) {
    // Create a new Date object representing today
    const today = new Date();
    
    // Use regex to capture hours, minutes, seconds, and AM/PM
    const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)?/);
    
    if (!match) return new Date(NaN); // Returns an Invalid Date if no match

    let [_, hoursStr, minutesStr, ampm] = match;
    let hours = parseInt(hoursStr, 10);
    let minutes = parseInt(minutesStr, 10);

    // Convert 12-hour format (AM/PM) to 24-hour format
    if (ampm) {
        if (ampm.toUpperCase() === "PM" && hours < 12) hours += 12;
        if (ampm.toUpperCase() === "AM" && hours === 12) hours = 0;
    }

    // Set the extracted time parts onto today's date
    today.setHours(hours, minutes,0, 0);
    return today;
}


const EditTimer=(props: GridCustomCellProps)=>{
    const pageContext = useContext(PageContext);
   // console.log(props);
    const { dataItem, isInEdit } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    // Create a new Date object representing today
    const fieldVal = timeStringToDate(dataValue.trim());
    console.log(fieldVal);
    const handleChange = (e: TimePickerChangeEvent) => {
        var locale=pageContext?.glSettings.Locale
        //console.log(e);
        const selTime= e.value?.toLocaleTimeString(locale,{hour:'numeric', minute:'2-digit', hour12:true}).toUpperCase();
        if (props.onChange) {
            props.onChange({
                 dataIndex: 0,
                 dataItem: props.dataItem,
                 field: props.field,
                 syntheticEvent: e.syntheticEvent,
                 value: selTime
            });
        }
    };

    return(
        <td {...props.tdProps}>
            {isInEdit ? (
                <TimePicker
                    onChange={handleChange}
                    format="hh:mm a"
                    value={fieldVal}
                >
                </TimePicker>
            ) : (
                dataValue
            )}
        </td>
    )
}

interface NumericChangeEvent {
    dataItem: any;
    field: string;
    value: number;
}

interface KeyboardEventPayload extends React.KeyboardEvent<HTMLInputElement> {
    key: string;
}

const EditNumeric=(props:GridCustomCellProps)=>{
    const { dataItem, isInEdit } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    const handleChange = (e: NumericTextBoxChangeEvent): void => {
        if (props.onChange) {
            props.onChange({
                dataIndex:0,
                dataItem: dataItem,
                syntheticEvent: e.syntheticEvent || new Event('change'),
                field: field,
                value: e.value,
            } as any);
        }
    };

  // Completely block the minus/hyphen key from being typed
  const handleKeyDown = (e: KeyboardEventPayload): void => {
    if (e.key === '-' || e.key === 'Minus') {
      e.preventDefault();
    }
  };

  return (
    <td>
        {isInEdit?
            <NumericTextBox
                value={field ? dataItem[field] : undefined}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                min={0}
            />
        :dataValue}
    </td>
  );

}

export default function AdminDeadline (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [deadlines, setDeadlines] = useState<ATOLDeadlines[]>([]);
    const [changes, setChanges] = useState<ATOLDeadlines[]>([]);

    const [siteSelected, setSiteSelected]=useState<SiteEntry>(
        {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:0,
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        }

    );
    const [pubSelected, setPubSelected]=useState<string[]>([]);
    const [siteFilter,setSiteFilter]=useState("");
    const [showNewDialog,setShowNewDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(deadlines,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [showDeleteSingle, setShowDeleteSingle]=useState(false);
    const [showDeletePub, setShowDeletePub]=useState(false);
    const [dlSelected,setDlSelected]=useState<ATOLDeadlines>()
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [edit, setEdit] = React.useState<EditDescriptor>({});

    const idGetter = getter('pubNum');

    const selectSite=(site:SiteEntry[])=>{
       
        setSiteSelected(site[0] || {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:"",
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        });
    }

     const selectPub=(pub:string[])=>{
  
        setPubSelected(pub);
    }


    const viewNewDialog=()=>{
        setShowNewDialog(true);
    }

    const hideNewDialog=()=>{
        setShowNewDialog(false);
    }

    const makeNewDeadline=(dl:NewDeadline)=>{
        console.log(dl);
        const types=dl.Type;
        const sections=dl.Section;
        const newDeadlines:ATOLDeadlines[]=[];
        types.forEach(type=>{
            sections.forEach(section=>{
                let tempInt=0;
                switch (section){
                    case "EORDER":
                        tempInt=1;
                        break;
                    case "MATERIALSIN":
                        tempInt=1;
                        break;
                    case "PROOFOUT":
                        tempInt=2;
                        break;
                    case "ECORR":
                        tempInt=3;
                        break;
                    case "PAGINATION":
                        tempInt=4
                        break;
                    case "CR-MATERIALS IN":
                        tempInt=5;
                        break;
                    case "CR-PROOF OUT":
                        tempInt=6;
                        break;
                }
                const UID=pubSelected[0]+"-"+type+"-"+section
                const newDeadline:ATOLDeadlines = {
                    uid:UID,
                    pubName:pubSelected[0],
                    type:"DAILY",
                    setting:type,
                    monTime:dl.Time,
                    monDays:dl.Days,
                    tueTime:dl.Time,
                    tueDays:dl.Days,
                    wedTime:dl.Time,
                    wedDays:dl.Days,
                    thurTime:dl.Time,
                    thurDays:dl.Days,
                    friTime:dl.Time,
                    friDays:dl.Days,
                    satTime:dl.Time,
                    satDays:dl.Days,
                    sunTime:dl.Time,
                    sunDays:dl.Days,
                    temp1:section,
                    temp2:"",
                    tempInt:tempInt
                }
                const exists = deadlines.find (f=>f.pubName.trim()===newDeadline.pubName.trim() && f.setting.trim()===newDeadline.setting.trim() && f.temp1.trim()===newDeadline.temp1.trim());
                if (!exists){
                    newDeadlines.push(newDeadline);
                }
            });
        });
        setDeadlines([...deadlines,...newDeadlines]);
        refreshChanges(newDeadlines);
        hideNewDialog();

    }


    const viewDeletePubWarning=()=>{
        setShowDeletePub(true);
    }

    const hideDeletePubWarning=()=>{
        setShowDeletePub(false);
    }

    const viewDeleteSingleWarning=()=>{
        setShowDeleteSingle(true);
    }

    const hideDeleteSingleWarning=()=>{
        setShowDeleteSingle(false);
    }

    const getDeadlines=()=>{
        if (pubSelected.length>0){
            getDeadlineList(pubSelected.join(",")).then(data=>{
                console.log(data);
                setDeadlines(data);
                //setDataResult(process(data, dataState));
            })
        }
    }

    const handleEditChange=(event: GridEditChangeEvent)=>{

        setEdit(event.edit);
    }

    const updateChanges =(item:ATOLDeadlines, field:string|undefined, value:string|number)=>{
        var locale=pageContext?.glSettings.Locale
        let found = false;
        const exists = changes.some(citem=>citem.uid===item.uid);
        const newItem = {...item,[field!]:value}
        console.log(newItem);
        const updatedList = exists?
            changes.map(citem=>citem.uid ===item.uid?{...citem,[field!]:value}:citem)
            : 
            [...changes,newItem]
        console.log(updatedList);
        setChanges(updatedList);        
    }


    const onItemChange=(event: GridItemChangeEvent)=>{

        if (event.field) {            
             setDeadlines((deadlines) =>
                 deadlines.map((item) =>
                     item.uid === event.dataItem.uid ? { ...item, [event.field!]: event.value, isChanged:true } : item
                 )
             );

        }
        updateChanges(event.dataItem,event.field, event.value);
    }

    const saveChanges=async ()=>{
        //write the changes to the database
        if (changes.length>0){
            //changes exist save them
            await saveDeadline(changes).then(data=>{
                if (data==="200"){
                    setChanges([]);
                    getDeadlines();
                }
            })
        }
    }


    useEffect(()=>{
        console.log(changes);
    },[changes])
   
    useEffect(()=>{
        console.log(pubSelected);
    },[pubSelected]);

    useEffect(()=>{
         if (siteSelected.code!=""){
            setSiteFilter(siteSelected.code);
        }
    },[siteSelected])

    useEffect(() => {   
        if (user?.loggedIn){
            //getDeadlines();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    const refreshChanges=(newDeadline:ATOLDeadlines[])=>{
        setChanges([...changes,...newDeadline]);
    }

    const formatCell = (props: GridCellProps) => {
        var cellData = props.dataItem["setting"] as string;
        var trimData="";
        if (cellData){
            trimData = cellData.trim();
        }
        var retVal = "";
        switch (trimData){
            case "EORDER":
                retVal="BOOKED";
                break;
            case "PROOFOUT":
                retVal="PROOF OUT";
                break;
            case "MATERIALSIN":
                retVal="MATERIALS IN";
                break;
            case "ECORR":
                retVal="CORRECTIONS";
                break;
            default:
                retVal=cellData;
                break; 
        }
        return (
            <td colSpan={1} className='k-table-td' role='gridcell' aria-colindex={3} aria-selected="false" data-grid-col-index="2">
                {retVal}
            </td>
        );
    }

    const deleteDeadline=(deadline: ATOLDeadlines) => {
        console.log("Delete Deadline:", deadline);
        setDlSelected(deadline);
        viewDeleteSingleWarning();
        //deleteSingleDeadline(deadline);
    }

    const confirmDeletePub=()=>{
        deletePubDeadline(pubSelected[0]).then(()=>{
            getDeadlines();
            hideDeletePubWarning();
        });
    }

    const confirmDeleteSingle=()=>{
        if (dlSelected){
            deleteSingleDeadline(dlSelected).then(()=>{
                getDeadlines();
                hideDeleteSingleWarning();
            });
        }
    }

    const dlButtons = (props: GridCellProps) => {
        return (
            <td>
                <a href="#" onClick={() => deleteDeadline(props.dataItem)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></a>
            </td>
        );
    }

    const ChangedRow = useCallback((props:GridRowProps) => {
    const { dataItem } = props;
    let rowClassName = '';

    if (dataItem && dataItem.isChanged) {
      rowClassName = 'changed-row'; 
    }
    const isChanged = changes.find(r=>r.uid===dataItem.uid);
    if (isChanged){
        rowClassName='changed-row';
    }

    // Merge the custom class with Kendo's default row props
    return <tr {...props} className={`${props.className} ${rowClassName}`} />;
    }, [changes]);


    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Deadline Management</h2>
            {showDeletePub?<ConfirmDialog title='Delete All Deadlines For Pub?' message='This will delete all deadlines for the selected publication. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Yes' cancelButtonText='No' onClose={hideDeletePubWarning} onConfirm={confirmDeletePub}/>:null}
            {showDeleteSingle?<ConfirmDialog title='Delete Selected Deadline?' message='This will delete the selected deadline for the selected publication. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Yes' cancelButtonText='No' onClose={hideDeleteSingleWarning} onConfirm={confirmDeleteSingle}/>:null}

            <Toolbar>
                <SiteList setReturnAction={selectSite} value={siteSelected} multi={false} className='toolbarField' valid={true}></SiteList>
                <PubList setReturnAction={selectPub} value={pubSelected} archiveOnly={false} liveOnly={true} type="single" siteFilter={siteFilter} className='toolbarField' returnField='name' onlineOnly={false} printOnly={false} same={false}></PubList>
                <Button title="Get Deadliines" themeColor={'primary'} type="button" onClick={getDeadlines}>
                    Get Deadlines
                </Button>
                {pubSelected[0]!==""?
                    <Button title="New Deadline" themeColor={'primary'} type="button" onClick={viewNewDialog}>
                        New Deadline
                    </Button>
                :null}
                {deadlines.length>0 && changes.length==0?
                    <Button title="Delete Pub Deadlines" themeColor={'primary'} type="button" onClick={viewDeletePubWarning}>
                        Delete Pub Deadlines
                    </Button>
                :null}
                {changes.length>0?
                    <Button title="Save Changes" themeColor={'warning'} type="button" onClick={saveChanges}>
                        Save Changes
                    </Button>         
                :null}     
            </Toolbar>
            <Grid
                dataItemKey='uid'
                id="deadlineGrid"
                className='adminGrid'
                sortable={false}
                selectable={{ enabled:true, mode: 'single' }}
                data={deadlines}
                autoProcessData={true}
                resizable={true}     
                edit={edit}
                cells={{
                    edit:{
                        numeric:EditNumeric,
                        date:EditTimer
                    }
                }}
                editable={{mode:"incell"}}
                onEditChange={handleEditChange}
                onItemChange={onItemChange}
                rows={{data:ChangedRow}}    // Pass the custom row renderer

            >
                {/* <GridColumn field='pubName' editable={false} title='Pub'/> */}
                {changes.length==0?<GridColumn cells={{data:dlButtons}} width={50}/>:null}
                <GridColumn field='setting' editable={false} title='Type' cells={{data:formatCell}}/>
                <GridColumn field='temp1' editable={false} title='Section'/>
                <GridColumn title='Monday' editable={false} children={[
                    <GridColumn field='monDays' title='Days' key="monDays" width={100} editor='numeric'/>,
                    <GridColumn field='monTime' title='Time' key="monTime"  editor='date'/>
                ]} />
                <GridColumn title='Tuesday' editable={false} children={[
                    <GridColumn field='tueDays' title='Days' key="tueDays" width={100} editor='numeric'/>,
                    <GridColumn field='tueTime' title='Time' key="tueTime" editor='date'/>
                ]} />
                <GridColumn title='Wednesday' editable={false} children={[
                    <GridColumn field='wedDays' title='Days' key="wedDays" width={100} editor='numeric'/>,
                    <GridColumn field='wedTime' title='Time' key="wedTime"  editor='date'/>
                ]} />
                <GridColumn title='Thursday' editable={false} children={[
                    <GridColumn field='thurDays' title='Days' key="thuDays" width={100} editor='numeric'/>,
                    <GridColumn field='thurTime' title='Time' key="thuTime"  editor='date'/>
                ]} />
                <GridColumn title='Friday' editable={false} children={[
                    <GridColumn field='friDays' title='Days' key="friDays" width={100} editor='numeric'/>,
                    <GridColumn field='friTime' title='Time' key="friTime"  editor='date'/>
                ]} />
                <GridColumn title='Saturday' editable={false} children={[
                    <GridColumn field='satDays' title='Days' key="satDays" width={100} editor='numeric'/>,
                    <GridColumn field='satTime' title='Time' key="satTime" editor='date'/>
                ]} />
                <GridColumn title='Sunday' editable={false} children={[
                    <GridColumn field='sunDays' title='Days' key="sunDays" width={100} editor='numeric'/>,
                    <GridColumn field='sunTime' title='Time' key="sunTime"  editor='date'/>
                ]} />
            </Grid>
            {showNewDialog?
                <NewDialog title={title} onSave={makeNewDeadline} onClose={hideNewDialog} action={action}></NewDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}